import DOMPurify from "dompurify";
import { ICheckableData } from "@/store/types/types";
import { AnyObj } from "./utils-types";

export const deepFreeze = <T extends AnyObj>(object: T): Readonly<T> => {
  for (const key in object) {
    const value = object[key];
    if (value && typeof value === "object") {
      deepFreeze(value);
    }
  }
  return Object.freeze(object);
};

export const checkObjectHasKeys = (obj: object) => {
  return Object.keys(obj).length !== 0;
};

export const listHasDuplicates = (array: string[]) => {
  const valuesTable = Object.create(null);
  for (const currentValue of array) {
    if (currentValue in valuesTable) return true;
    valuesTable[currentValue] = true;
  }
  return false;
};

export const checkDataExists = (item: ICheckableData) => {
  if (typeof item == "object") return checkObjectHasKeys(item);
  if (typeof item == "string") return item.length;
  if (typeof item == "number" || typeof item == "boolean") return true;
  return false;
};

export const sanitizedHtml = (html: string | Node) => {
  if (typeof window === "undefined" || !html) {
    return "";
  }
  return DOMPurify.sanitize(html);
};

export const cleanString = (value: string) => {
  let cleanValue = value.replace(/[^a-zA-Z0-9 ]/g, ""); // Remove caracter special menos espaço
  cleanValue = cleanValue.trim(); // Remove espaço no comelo e final da string
  return cleanValue.replace(/\s+/g, " "); // Troca espaços consecutivos por simples
};
